import EmbeddedPostController from "./EmbeddedPostController";
import EmbeddedPostUI from "./EmbeddedPostUI";
import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import "./styles.css";

export default class EmbeddedPost extends Plugin {
    static get requires() {
        return [ EmbeddedPostController, EmbeddedPostUI ];
    }
}